import { render, staticRenderFns } from "./HanbookInfoBox.vue?vue&type=template&id=ba3e13e0&scoped=true&"
import script from "./HanbookInfoBox.vue?vue&type=script&lang=js&"
export * from "./HanbookInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./HanbookInfoBox.vue?vue&type=style&index=0&id=ba3e13e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3e13e0",
  null
  
)

export default component.exports